<template>
  <div style="display: inline-block" class="higher-search-values">
    <!--判断是什么类型 input select等-->
    <!--select-->
    <!--属性-->
    <el-select @change="update" class="ifSelect" v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'select' && items.relationship !== 'empty' && items.relationship !== 'not empty' && items.selectedOptions[0] === 'attr'" v-model="curValue" placeholder="请选择查询内容">
      <el-option
        v-for="i in item.option"
        :key="i"
        :label="i"
        :value="i">
      </el-option>
    </el-select>
    <!--属性-->
    <el-select @change="update" class="ifSelect" v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'radio' && items.relationship !== 'empty' && items.relationship !== 'not empty' && items.selectedOptions[0] === 'attr'" v-model="curValue" placeholder="请选择查询内容">
      <el-option
        v-for="i in item.option"
        :key="i"
        :label="i"
        :value="i">
      </el-option>
    </el-select>
    <!--群组-->
    <el-select @change="update" filterable class="ifSelect" v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'select' && items.selectedOptions[0] === 'group'" v-model="curValue" placeholder="请选择查询内容">
      <el-option
        v-for="i in item.option"
        :key="i.value"
        :label="i.label"
        :value="i.value">
      </el-option>
    </el-select>
    <!--事件-->
    <el-select @blur="update(items)" filterable @change="eventChange(items)" class="ifSelect" v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'select' && items.selectedOptions[0] === 'event'" v-model="curValue" placeholder="请选择查询内容">
      <el-option
        v-for="i in item.option"
        :key="i.value"
        :label="i.label"
        :value="i.value">
      </el-option>
    </el-select>
    <!--input-->
    <el-input @input="update" v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'input' && items.relationship !== 'empty' && items.relationship !== 'not empty'" v-model="curValue" placeholder="请输入查询内容"></el-input>
    <!--datePicker-->
    <el-date-picker
      v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'datePicker' && items.relationship !== 'empty' && items.relationship !== 'not empty' && items.relationship !== 'gtele'"
      v-model="curValue"
      type="date"
      class="dateTimePicker"
      @change="update"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
    <!--dateTimePicker-->
    <el-date-picker
      v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'dateTimePicker' && items.relationship !== 'empty' && items.relationship !== 'not empty' && items.relationship !== 'gtele'"
      v-model="curValue"
      type="datetime"
      class="dateTimePicker"
      @change="update"
      value-format="yyyy-MM-dd"
      placeholder="选择时间和日期">
    </el-date-picker>
    <!--区间类日期选择-->
    <el-date-picker
      v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'datePicker' && items.relationship !== 'empty' && items.relationship !== 'not empty' && items.relationship === 'gtele'"
      v-model="curValue"
      type="daterange"
      range-separator="至"
      class="dateTimePickers"
      start-placeholder="开始日期"
      @change="update"
      value-format="yyyy-MM-dd"
      end-placeholder="结束日期">
    </el-date-picker>
    <!--区间类日期时间选择-->
    <el-date-picker
      v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'dateTimePicker' && items.relationship !== 'empty' && items.relationship !== 'not empty' && items.relationship === 'gtele'"
      v-model="curValue"
      type="datetimerange"
      range-separator="至"
      class="dateTimePickers"
      start-placeholder="开始日期"
      @change="update"
      value-format="yyyy-MM-dd"
      end-placeholder="结束日期">
    </el-date-picker>
    <!--addressPicker-->
    <el-cascader
      v-if="items.selectedOptions.length > 0 && items.selectedOptions[1].split('@')[1] === 'addressPicker' && items.relationship !== 'empty' && items.relationship !== 'not empty'"
      class="area"
      size="large"
      :options="addressOptions"
      v-model="curValue"
      @change="update">
    </el-cascader>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { getCustomerAttributeList, getBigWheelList, getMessageListForNode, getGroupList, getCustomerEventList, getWechatPublicListForNode, getWePagesListForNode } from '@/api/customer.js'
import { mapGetters } from 'vuex'
export default {
  name: '',
  props: ['item', 'realValue', 'value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      curValue: this.value,
      items: this.item,
      qrcodes: [],
      addressOptions: regionDataPlus
    }
  },
  watch: {
    value: function (val) {
      this.curValue = val
    },
    item: function (val) {
      this.items = val
    }
  },
  computed: {
    ...mapGetters([
      'getQuery'
    ])
  },
  methods: {
    // 事件选择公众号离开的时候
    eventChange(item) {
      // 处理公众号二维码选择问题
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[1].split('@')[0] === 'scan_cap_qrcode') {
        for (let j in item.option) {
          item.value = this.curValue
          if (item.value === item.option[j].id) {
            this.qrcodes = item.option[j].qrcode
          }
        }
        item.qrcode = ''
      }
      this.$emit('getQrcodes', this.qrcodes)
    },
    update() {
      this.$emit('change', this.curValue)
    }
  },
  mounted() {
  },
  created() {
    this.update()
    this.curValue = this.realValue
  }
}
</script>

<style scoped>

</style>
